import React from 'react'
import { Link } from 'react-router'
import EditIcon from '../../img/icons/general-icons/icon_edit.png'

export default class LinkUpdatePatient extends React.Component {
  render () {
    var url = 'patient/' + this.props.numeroDocumento
    return (
      <Link to={url}><img src={EditIcon}/></Link>
    )
  }
}

/* Validate Props */
LinkUpdatePatient.propTypes = {
  rowData: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Search/LinkUpdatePatient.js